import { AxiosInstance } from "axios";
import { RapportGenere } from "../types/RapportGenere";
import { Rapport } from "../types/Rapport";

export const rapportGenereService = {
  /**
   * Create a generated report for a given rapport id.
   * Endpoint: POST /rapport-genere/{idRapport}
   * Body: { idIle, idRegion, idCommune, idLocalite }
   */
  createRapportGenere: async (
    api: AxiosInstance,
    idRapport: number,
    locality?: { idIle?: number; idRegion?: number; idCommune?: number; idLocalite?: number } | null
  ): Promise<RapportGenere | null> => {
    try {
      const payload = locality || { idIle: null, idRegion: null, idCommune: null, idLocalite: null };
      const response = await api.post(`/rapport-genere/generate/${idRapport}`, payload);

      if (!response.data) return null;

      if (response.data.rapportGenere) return response.data.rapportGenere as RapportGenere;
      return response.data as RapportGenere;
    } catch (error: any) {
      console.error(`Erreur lors de la création du rapport généré pour rapport ${idRapport}:`, error);
      return null;
    }
  },

  getAllRapportsGeneres: async (api: AxiosInstance): Promise<RapportGenere[]> => {
    try {
      const response = await api.get("/rapport-genere");
      return response.data as RapportGenere[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des rapports générés :", error);
      return [];
    }
  },

  /**
   * Get generated report indicator data for a given generated report id.
   * Endpoint: GET /rapport-genere/{idRapportGenere}/data
   * Returns a mapping of indicatorId -> { meta, rows }
   */
  getRapportGenereData: async (
    api: AxiosInstance,
    idRapportGenere: number
  ): Promise<Record<number, { meta: any; rows: Record<string, any>[] }>> => {
    try {
      const response = await api.get(`/rapport-genere/${idRapportGenere}/data`);
      return response.data as Record<number, { meta: any; rows: Record<string, any>[] }>;
    } catch (error: any) {
      console.error(`Erreur lors de la récupération des données du rapport généré ${idRapportGenere}:`, error);
      return {};
    }
  },

  /**
   * Update status of a generated report.
   * Endpoint: PATCH /rapport-genere/{idRapportGenere}/status
   * Body: { status: number }
   */
  updateStatus: async (
    api: AxiosInstance,
    idRapportGenere: number,
    status: number
  ): Promise<RapportGenere | null> => {
    try {
      const response = await api.patch(`/rapport-genere/${idRapportGenere}/status`, { status });
      if (!response.data) return null;
      if (response.data.rapportGenere) return response.data.rapportGenere as RapportGenere;
      return response.data as RapportGenere;
    } catch (error: any) {
      console.error(`Erreur lors de la mise à jour du statut du rapport généré ${idRapportGenere}:`, error);
      return null;
    }
  },

  getResultDataForGraph: async (
    api: AxiosInstance,
    params: {
      idFenetre?: number;
      idSousFenetre?: number;
      idIle?: number;
      idRegion?: number;
      idCommune?: number;
      idLocalite?: number;
    }
  ): Promise<string[]> => {
    try {
      
      const query = new URLSearchParams();
      if (params.idFenetre != null) query.append("idFenetre", params.idFenetre.toString());
      if (params.idSousFenetre != null) query.append("idSousFenetre", params.idSousFenetre.toString());
      if (params.idIle != null) query.append("idIle", params.idIle.toString());
      if (params.idRegion != null) query.append("idRegion", params.idRegion.toString());
      if (params.idCommune != null) query.append("idCommune", params.idCommune.toString());
      if (params.idLocalite != null) query.append("idLocalite", params.idLocalite.toString());

      const response = await api.get(`/rapport-genere/graph-data?${query.toString()}`);
      return response.data as string[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des données pour le graph :", error);
      return [];
    }
  },
};
